export const initializeAppEnv = (): AppEnv => {
	return {
		backendUrl: globalThis.___STTRCONF___?.backendUrl,
		env: globalThis.___STTRCONF___?.env,
		muiLicense:
			globalThis.___STTRCONF___?.muiLicense ?? process.env['VITE_MUI_LICENSE'],
		version: globalThis.___STTRCONF___?.version ?? process.env['VITE_VERSION'],
	};
};

export type AppEnv = {
	backendUrl?: string;
	env?: string;
	muiLicense?: string;
	version?: string;
};
